export const stringCompare = (firstString: string, lastString: string): boolean => {
  return !(firstString === lastString)
};